import { Injectable } from '@angular/core';
import {
  ExercicioService,
  FuncaoService, GlobalService, OrgaoService,
  Relatorio
} from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FichaReceitaService } from '../../../../planejamento/ficha-receita/service/ficha-receita.service';

@Injectable({
  providedIn: 'root'
})
export class BalanceteReceitaService {

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected frService: FichaReceitaService,
    protected exercicioService: ExercicioService,
    protected orgaoService: OrgaoService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService
  ) { }
  /* -------------------------- balancete da receita -------------------------*/

  async montarBalanceteReceita(mes: number, exercicioId: number, orgaos: number[], login: any) {
    const parametros: {} = {};
    if (mes) {
      parametros['mes'] = mes;
    }
    if (exercicioId) {
      parametros['ano'] = exercicioId;
    }
    parametros['orgaos'] = orgaos.join();
    const ex = await this.exercicioService.obterId(exercicioId).toPromise();
    this.frService.balancete(parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('Balancete Analítico da Receita - Referência: ' +
          this.globalService.obterDataBR().monthNames[mes - 1].toLocaleUpperCase() + '/' + ex.ano
          , login.usuario.nome,
          login.orgao.nome, login.brasao, this.balanceteReceitaConteudo(dados),
          'landscape', 'Balancete Analítico da Receita',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          });
      });
  }

  balanceteReceitaConteudo(dados: any[]): {}[] {
    const registros: {}[] = [
      [{
        text: 'DEMONSTRAÇÃO DA RECEITA ORÇAMENTÁRIAS SEGUNDO A CATEGORIA ECONÔNICA',
        colSpan: 9, alignment: 'center', bold: true
      },
        '', '', '', '', '', '', '', ''],
      [
        { text: '\nFICHA', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: '\nRECURSO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: '\nESPECIFICAÇÕES', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'MOVIMENTO DA RECEITA', alignment: 'center', colSpan: 3, bold: true, fontSize: 7 },
        '', '',
        { text: 'CALCULOS', alignment: 'center', colSpan: 3, bold: true, fontSize: 7 },
        '', '',
      ],
      ['', '', '',
        { text: 'ANTERIOR', alignment: 'right', bold: true, fontSize: 7 },
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADA', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'PREVISÃO', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'AJUSTE', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'DIFERENÇA', alignment: 'center', bold: true, fontSize: 7 }
      ]
    ];
    const categoria = {};
    let totalAnterior = 0.00;
    let totalMes = 0.00;
    let totalArrecadado = 0.00;
    let totalPrevisao = 0.00;
    let totalAjuste = 0.00;
    let totalDiferenca = 0.00;
    for (const registro of dados) {

      if (!categoria['nome'] || categoria['nome'] !== registro['categoria']) {
        if (categoria['nome']) {
          registros.push(this.retornarLinhaSomaCategoria(categoria));
        }
        categoria['ficha'] = registro['fh_numero'];
        categoria['codigo'] = registro['r_codigo'];
        categoria['recurso'] = `${registro['re_codigo']} ${registro['a_codigo']}`;
        categoria['nome'] = registro['categoria'];
        categoria['anterior'] = 0.00;
        categoria['mes'] = 0.00;
        categoria['arrecadado'] = 0.00;
        categoria['previsao'] = 0.00;
        categoria['ajuste'] = 0.00;
        categoria['diferenca'] = 0.00;
        registros.push([
          {
            text: categoria['nome'], colSpan: 9,
            bold: true, fontSize: 9
          },
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ]);
      }
      const vlAnterior: number = registro['arrecadado_anterior'];
      const vlMes: number = registro['arrecadado_mes'];
      const vlArrecadado: number = registro['arrecadado'];
      const vlPrevisao: number = registro['fh_valor_orcado'] ? registro['fh_valor_orcado'] : 0.00;
      const vlAjuste: number = registro['ajuste'];
      const vlDiferenca: number = +vlArrecadado - +vlPrevisao;
      categoria['anterior'] += +vlAnterior;
      categoria['mes'] += +vlMes;
      categoria['arrecadado'] += +vlArrecadado;
      categoria['previsao'] += +vlPrevisao;
      categoria['ajuste'] += +vlAjuste;
      categoria['diferenca'] += +vlDiferenca;
      totalAnterior += +vlAnterior;
      totalMes += +vlMes;
      totalArrecadado += +vlArrecadado;
      totalAjuste += +vlAjuste;
      totalPrevisao += +vlPrevisao;
      totalDiferenca += +vlDiferenca;

      registros.push([
        {
          text: this.funcaoService.strZero(registro['fh_numero'], 3),
          border: [true, false, true, false], alignment: 'center', fontSize: 7
        },
        {
          text: `${registro['re_codigo']} ${registro['a_codigo']}`,
          border: [true, false, true, false], alignment: 'center', fontSize: 7
        },
        {
          text: this.funcaoService.mascarar('#.#.##.##', registro['r_codigo']) + ' ' + registro['r_nome'],
          border: [true, false, true, false], fontSize: 7
        },
        { text: this.funcaoService.convertToBrNumber(vlAnterior), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(vlMes), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(vlArrecadado), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(vlPrevisao), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(vlAjuste), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(vlDiferenca), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
      ]);
    }
    if (categoria['nome']) {
      registros.push(this.retornarLinhaSomaCategoria(categoria));
      registros.push([
        {
          text: 'TOTAL GERAL:', colSpan: 3,
          bold: true, fontSize: 7
        },
        '',
        '',
        { text: this.funcaoService.convertToBrNumber(totalAnterior), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalMes), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalArrecadado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalPrevisao), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalAjuste), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalDiferenca), bold: true, alignment: 'right', fontSize: 7 },
      ]);
    }
    return [{
      layout: 'linhas',
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        dontBreakRows: true,
        headerRows: 3,
        widths: ['auto', 'auto', '*', 60, 60, 60, 60, 60, 60],
        body: registros
      }
    }];
  }

  retornarLinhaSomaCategoria(categoria: {}) {
    return [
      {
        text: 'SOMA', colSpan: 3,
        bold: true, fontSize: 7
      },
      '',
      '',
      { text: this.funcaoService.convertToBrNumber(categoria['anterior']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(categoria['mes']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(categoria['arrecadado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(categoria['previsao']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(categoria['ajuste']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(categoria['diferenca']), bold: true, alignment: 'right', fontSize: 7 },
    ];
  }
}
